module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/activities/activities.component.css
// module id = ./src/app/Pages/activities/activities.component.css
// module chunks = main